
import {storeStack} from 'ccw-frontend-common'

  
  export default storeStack.navigationStack;
  